module.exports = "https://www.gc-pro.gnp.com.mx/0964e87bb4ae7da00adca3aa4411eb25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-down.svg
// module id = 107
// module chunks = 0 1